import React, { useState } from 'react';
import CardCategory from '../components/cards/cardCategory/CardCategory';
import CardDirectory from '../components/cards/cardDirectory/CardDirectory';
import ScrollContainer from 'react-indiana-drag-scroll';

import { ICategory, ITenant } from './types';

import './Directory.css';
import SvgArrow from '../svg/Arrow';
import { useSelector } from 'react-redux';
import { translate } from '../i18n';
import { RootState } from '../store';
import axios from '../api/axios';
import { useParams } from 'react-router-dom';

interface IDirectoryPageProps {}

let keyIterator = 0;

const DirectoryPage: React.FC<IDirectoryPageProps> = (props) => {
    const [selectedTab, setSelectedTab] = useState(-1);
    const [tenants, setTenants] = useState<ITenant[]>(new Array<ITenant>());
    const [categories, setCategories] = useState<ICategory[]>(new Array<ICategory>());
    const { language } = useSelector((state: RootState) => state.lang);

    const { buildingId } = useParams();
    const GET_TENANTS_URL = '/api/hblogin/repository/GetLocatairesByBuildingId';
    const GET_TENANT_CATEGORIES_URL = '/api/hblogin/repository/GetTenantCategoriesByBuildingId';

    const updateTenants = (tenants: ITenant[]) => {
        tenants = tenants.filter((tenant) => tenant.suites);
        tenants = tenants.sort(function (a, b) {
            if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
            if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
            return 0;
        });
        setTenants(tenants);
    };

    const updateCategories = (categories: ICategory[]) => {
        categories = categories.sort(function (a, b) {
            if (a.frenchTitle.toLowerCase() < b.frenchTitle.toLowerCase()) return -1;
            if (a.frenchTitle.toLowerCase() > b.frenchTitle.toLowerCase()) return 1;
            return 0;
        });
        setCategories(categories);
    };

    React.useEffect(() => {
        axios.get<ITenant[]>(`${GET_TENANTS_URL}`, { params: { buildingId: buildingId } }).then((response) => updateTenants(response.data));
        axios.get<ICategory[]>(`${GET_TENANT_CATEGORIES_URL}`, { params: { buildingId: buildingId } }).then((response) => updateCategories(response.data));
    }, []);

    return (
        <div className="Directory">
            <div className="DirectoryLeft">
                <div className="CategoryListOuter">
                    <div className="CategoryListHeader">{translate('Directory', language)}</div>
                    <ScrollContainer className="CategoryListBody TouchScroll" horizontal={false}>
                        {categories.map((item, i) => (
                            <CardCategory key={i} index={item.id} englishTitle={item.englishTitle} frenchTitle={item.frenchTitle} setSelectedTab={setSelectedTab} activeTab={item.id === selectedTab} />
                        ))}
                    </ScrollContainer>
                    <div className="CategoryListFooter">
                        <button className="CategoryCardOuter CategoryDisplayAll Drop-Shadow " onClick={() => setSelectedTab(-1)}>
                            <div className="CategoryDisplayAllTitle">{translate('DisplayAll', language)}</div>
                            <SvgArrow height={30} width={30} color="#FFFFFF" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="DirectoryRight TouchScroll">
                <ScrollContainer className="DirectoryDataOuter TouchScroll" horizontal={false}>
                    {tenants?.map((item) =>
                        item?.categoryId === selectedTab
                            ? item.suites.split(' ').map((suite) => {
                                  return <CardDirectory key={keyIterator++} index={keyIterator++} id={item.id} title={item.title} floor={suite} suite={item.id} category={item.categoryId} />;
                              })
                            : selectedTab === -1
                            ? item.suites.split(' ').map((suite) => {
                                  return <CardDirectory key={keyIterator++} index={keyIterator++} id={item.id} title={item.title} floor={suite} suite={item.id} category={item.categoryId} />;
                              })
                            : null
                    )}
                </ScrollContainer>
            </div>
        </div>
    );
};

export default DirectoryPage;
